import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bf3ef428")

_pushScopeId("data-v-bf3ef428")
const _hoisted_1 = { class: "algo-container" }
const _hoisted_2 = { class: "left-panel" }
const _hoisted_3 = { style: {"margin":"1rem 0","text-align":"center"} }
const _hoisted_4 = { class: "is-size-3" }
const _hoisted_5 = {
  key: 0,
  class: "is-flex",
  style: {"justify-content":"center","margin-bottom":"1rem"}
}
const _hoisted_6 = { class: "radio radio-label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Max Heap ")
const _hoisted_8 = { class: "radio radio-label" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Min Heap ")
const _hoisted_10 = { style: {"border-top":"1px solid #4eb380","border-bottom":"1px solid #4eb380"} }
const _hoisted_11 = { style: {"margin-top":"3rem"} }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { style: {"margin-left":"10%"} }, "Add New Node", -1)
const _hoisted_13 = {
  class: "is-flex",
  style: {"align-items":"center","justify-content":"space-evenly"}
}
const _hoisted_14 = { class: "is-size-4" }
const _hoisted_15 = {
  key: 0,
  style: {"margin-top":"1rem"}
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { style: {"margin-left":"10%"} }, "Delete Node", -1)
const _hoisted_17 = {
  class: "is-flex",
  style: {"align-items":"center","justify-content":"space-evenly"}
}
const _hoisted_18 = { class: "is-size-4" }
const _hoisted_19 = {
  key: 1,
  style: {"margin-top":"1rem"}
}
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { style: {"margin-left":"10%"} }, "Search Node", -1)
const _hoisted_21 = {
  class: "is-flex",
  style: {"align-items":"center","justify-content":"space-evenly"}
}
const _hoisted_22 = { class: "is-size-4" }
const _hoisted_23 = { class: "legend" }
const _hoisted_24 = /*#__PURE__*/_createVNode("h1", {
  class: "is-size-4",
  style: {"align-self":"center"}
}, "Legend", -1)
const _hoisted_25 = {
  class: "is-flex",
  style: {"margin-top":"5px"}
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" On this node ")
const _hoisted_27 = {
  class: "is-flex",
  style: {"margin-top":"5px"}
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Comparing Nodes ")
const _hoisted_29 = {
  class: "is-flex",
  style: {"margin-top":"5px"}
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Swapping Nodes ")
const _hoisted_31 = { class: "canvas-container" }
const _hoisted_32 = /*#__PURE__*/_createVNode("canvas", { id: "canvas" }, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "traversal-output"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AlgoNavBar = _resolveComponent("AlgoNavBar")
  const _component_SVG = _resolveComponent("SVG")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_AlgoNavBar, {
      algorithmsList: _ctx.allMainDsAlgos,
      buttonsList: [],
      selectedAlgo: _ctx.selectedMainDsAlgo.name,
      onAlgorithmChanged: _ctx.algorithmChanged,
      algoSpeed: _ctx.animationSpeed,
      "onUpdate:algoSpeed": _cache[1] || (_cache[1] = ($event: any) => (_ctx.animationSpeed = $event)),
      algoSpeedModifiers: { sync: true }
    }, null, 8, ["algorithmsList", "selectedAlgo", "onAlgorithmChanged", "algoSpeed"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.selectedMainDsAlgo.name) + " Algorithms ", 1)
          ]),
          (_ctx.isHeapSelected)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("label", _hoisted_6, [
                  _createVNode("input", {
                    type: "radio",
                    name: "min-max-heap",
                    checked: "",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTypeOfHeap('Maximum')))
                  }, null, 32),
                  _hoisted_7
                ]),
                _createVNode("label", _hoisted_8, [
                  _createVNode("input", {
                    type: "radio",
                    name: "min-max-heap",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTypeOfHeap('Minimum')))
                  }, null, 32),
                  _hoisted_9
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navbarButtons[
                            _ctx.selectedMainDsAlgo.name
                        ], (algo, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "left-panel-algos",
              key: index,
              onClick: algo.handler,
              onContextmenu: 
                            (e) => _ctx.getMoreInfoAboutAlgorithm(e, algo.name)
                        
            }, _toDisplayString(algo.name === "delete_from_heap"
                                ? `Take out ${_ctx.typeOfHeap} element`
                                : algo.name), 41, ["onClick", "onContextmenu"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _withDirectives(_createVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewNodeValue = $event)),
              onKeydown: _cache[5] || (_cache[5] = ($event: any) => ($event.key === 'Enter' ? _ctx.addNode() : ''))
            }, null, 544), [
              [_vModelText, _ctx.addNewNodeValue]
            ]),
            _createVNode("button", {
              class: "button is-success is-small",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addNode && _ctx.addNode(...args)))
            }, [
              _createVNode("span", _hoisted_14, [
                _createVNode(_component_SVG, {
                  name: _ctx.svgNames.plus
                }, null, 8, ["name"])
              ])
            ])
          ])
        ]),
        (!_ctx.isHeapSelected)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", _hoisted_17, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteNodeValue = $event)),
                  onKeydown: _cache[8] || (_cache[8] = ($event: any) => (
                                $event.key === 'Enter' ? _ctx.deleteNode() : ''
                            ))
                }, null, 544), [
                  [_vModelText, _ctx.deleteNodeValue]
                ]),
                _createVNode("button", {
                  class: "button is-danger is-small",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteNode && _ctx.deleteNode(...args)))
                }, [
                  _createVNode("span", _hoisted_18, [
                    _createVNode(_component_SVG, {
                      name: _ctx.svgNames.delete
                    }, null, 8, ["name"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTreeSelected)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchNodeValue = $event)),
                  onKeydown: _cache[11] || (_cache[11] = ($event: any) => (
                                $event.key === 'Enter' ? _ctx.searchNode() : ''
                            ))
                }, null, 544), [
                  [_vModelText, _ctx.searchNodeValue]
                ]),
                _createVNode("button", {
                  class: "button is-info is-small",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.searchNode && _ctx.searchNode(...args)))
                }, [
                  _createVNode("span", _hoisted_22, [
                    _createVNode(_component_SVG, {
                      name: _ctx.svgNames.search
                    }, null, 8, ["name"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode("div", _hoisted_25, [
            _createVNode("div", {
              class: "cell-info-div",
              style: { backgroundColor: _ctx.nodeHoverColor.hex }
            }, null, 4),
            _hoisted_26
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("div", {
              class: "cell-info-div",
              style: { backgroundColor: _ctx.pointerColor1.hex }
            }, null, 4),
            _hoisted_28
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", {
              class: "cell-info-div",
              style: { backgroundColor: _ctx.pointerColor2.hex }
            }, null, 4),
            _hoisted_30
          ])
        ])
      ]),
      _createVNode("div", _hoisted_31, [
        _hoisted_32,
        (_ctx.treeTraversalOutput.show)
          ? (_openBlock(), _createBlock("div", _hoisted_33, _toDisplayString(_ctx.treeTraversalOutput.output), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showAlgoDescriptionModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          modalTitle: 'ksdf',
          modalInfo: 'skjfoir',
          onCloseModal: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showAlgoDescriptionModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
})